module.exports = __webpack_public_path__ + "img/featur_1.b7212bb5.jpg";